"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
class CustomerCalorieBudgetAdapter {
    adapt(response) {
        const calorieBudgets = response.data.coachTrainee.currentPeriod.calorieBudgets.sort(({ week: a }, { week: b }) => {
            if (a === b) {
                return 0;
            }
            return a > b ? -1 : 1;
        });
        const forTrainingDayBudget = calorieBudgets.find(({ isForTrainingDays }) => isForTrainingDays);
        const forNonTrainingDayBudget = calorieBudgets.find(({ isForTrainingDays }) => !isForTrainingDays);
        if (forTrainingDayBudget === undefined) {
            throw new exception_1.DomainException("User has no training day budget");
        }
        if (forNonTrainingDayBudget === undefined) {
            throw new exception_1.DomainException("User has no non-training day budget");
        }
        return {
            forNonTrainingDay: {
                calories: forNonTrainingDayBudget.calories,
                carbohydrates: forNonTrainingDayBudget.carbohydrates,
                fats: forNonTrainingDayBudget.fats,
                proteins: forNonTrainingDayBudget.proteins,
                fibers: forNonTrainingDayBudget.fibers,
            },
            forTrainingDay: {
                calories: forTrainingDayBudget.calories,
                carbohydrates: forTrainingDayBudget.carbohydrates,
                fats: forTrainingDayBudget.fats,
                proteins: forTrainingDayBudget.proteins,
                fibers: forTrainingDayBudget.fibers,
            },
            isSecured: [forTrainingDayBudget, forNonTrainingDayBudget].some((budget) => budget.isSecured),
        };
    }
}
exports.default = CustomerCalorieBudgetAdapter;
//# sourceMappingURL=CustomerCalorieBudgetAdapter.js.map